export const typeOptions = [
  { value: "photo", label: "Site Progress Photo", orderBy: "takenDatetime" },
  {
    label: "Audit",
    value: "audit",
  },
  {
    label: "CE",
    value: "ce",
  },
  {
    label: "CP",
    value: "cp",
  },
  {
    label: "CSF",
    value: "csf",
  },
  {
    label: "EWN",
    value: "ewn",
  },
  {
    label: "MSF",
    value: "msf",
  },
  {
    label: "PMI",
    value: "pmi",
  },
  {
    label: "Quotation",
    value: "quotation",
  },
  {
    label: "RFI",
    value: "rfi",
  },
  {
    label: "RR",
    value: "rr",
  },
];